import { inject, signal } from '@angular/core';
import { StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { Station, StationGroup } from '../../../models';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimViewGroup {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  router = inject(Router);

  stations: Station[] = [];
  isLoading = signal(true);
  routes = PublicRoutes;
  selectedGroup: StationGroup | null = this.stationsService.getSelectedGroup();

  init() {
    if (!this.selectedGroup) {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }
}